import { ArticlesResponse } from "../../data/models/article";
import ArticlesRepository from "../repositories/articlesRepository";

interface ArticlesService {
  getArticles(page?: number): Promise<ArticlesResponse>;
  loadMoreArticles(
    page?: number,
    currentCount?: number,
  ): Promise<ArticlesResponse>;
  getArticle(id: string): Promise<ArticlesResponse>;
}

export class ArticlesServiceImpl implements ArticlesService {
  getArticles(page = 1): Promise<ArticlesResponse> {
    return ArticlesRepository().getArticles(page);
  }

  loadMoreArticles(page = 1, currentCount = 0): Promise<ArticlesResponse> {
    return ArticlesRepository().loadMoreArticles(page, currentCount);
  }

  getArticle(id: string): Promise<ArticlesResponse> {
    return ArticlesRepository().getArticle(id);
  }
}

export default ArticlesService;
